import React from "react";
import { Button } from "react-bootstrap";
import "./Congratulations_step.css";
import { Link } from "react-router-dom";
import Contacgrats_lottie from "./contacgrats_lottie/Contacgrats_lottie";

function Congratulations_step() {
  const handleBackHome = () => {
    sessionStorage.setItem("isRegistered", "true"); // ✅ save only for this session
  };

  return (

    <>
      <section className="Congratulations_step">
        <div className="stepform_form">
          <div className="congrats_text_holder">
            <h4>CONGRATULATIONS!</h4>
            <p>
              You’ve successfully activated your plan. Your details will be sent to
              you in just a moment.
            </p>
          </div>

          <div className="buttons">
            <Link to={"/"} onClick={handleBackHome}>
              <Button className="back_btn form_btn mt-4">Back To Home</Button>
            </Link>
          </div>
        </div>
        <div className="lottie_holder">
          <Contacgrats_lottie />
        </div>
      </section>

    </>
  );
}

export default Congratulations_step;
